import React, { useState, useEffect, useRef } from 'react'
import { QlikItem } from './QlikItem'
import { useTheme, makeStyles } from '@material-ui/core'
import { stylesMui } from './styles/qlikReportTab.styles'

import styles from './css/qlik-report-styles.css'

export const QlikReportTab = ({ widgets, qApp, transformRatio }) => {
  const container = useRef()
  const [isLoaded, setIsLoaded] = useState(false)
  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  return (
    <React.Fragment>
      <div className={styles.tabContent} ref={container}>
        <div className={styles.reportCanvas}>
          {isLoaded &&
            widgets.map((value, index) => {
              return (
                <QlikItem
                  key={index}
                  widget={value}
                  qApp={qApp}
                  transformRatio={transformRatio}
                />
              )
            })}
        </div>
      </div>
    </React.Fragment>
  )
}
